import { Tabs as ReactTabs } from "react-tabs";

import "./_tabs.scss";

function Tabs({ children, ...rest }) {
  return <ReactTabs {...rest}>{children}</ReactTabs>;
}

export { Tabs };
